import React, { PureComponent } from 'react'
import { withRouter, Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { Icon, Tooltip } from 'gipsy-ui'
import { translations, styles } from 'gipsy-misc'
import { connect } from 'react-redux'
import { DesktopSupportChat } from 'features/supportchat'
import { elementHasNotifications } from 'features/notifications/utils'
import { getSrc } from 'utils/image'

const mapStateToProps = state => ({
  notifications: state.notifications.list
})

class Navbar extends PureComponent {
  state = {
    showSupportChat: false
  }

  isFocusView = () => {
    const { location } = this.props
    return location.pathname === '/focusview'
  }

  isTodolist = () => {
    const { location } = this.props
    return (
      location.pathname === '/' ||
      location.pathname === '/archive' ||
      location.pathname === '/index.html' ||
      location.pathname.indexOf('/calendar') !== -1 ||
      location.pathname === '/focusview'
    )
  }

  isTeam = () => {
    const { location } = this.props
    return location.pathname === '/team' || location.pathname === '/team/archive'
  }

  isReports = () => {
    const { location } = this.props
    return location.pathname === '/reports'
  }

  isSettings = () => {
    const { location } = this.props
    return location.pathname === '/settings'
  }

  render() {
    const { notifications } = this.props
    const { showSupportChat } = this.state

    return !this.isFocusView() ? (
      <React.Fragment>
        <div className="navbar">
          <div className="navbar-header">
            <Link to="/">
              <img src={getSrc('/images/gipsybot.svg')} alt="logo" />
            </Link>
          </div>
          <div className="navbar-body">
            <div className="section">
              <BackgroundLink to="/" className={this.isTodolist() && 'active'}>
                <BackgroundIcon
                  className="todolist-icon"
                  size={24}
                  icon="Checked"
                  fill="white"
                  isActive={this.isTodolist()}
                  dot={elementHasNotifications(notifications, 'todolist')}
                />
                <Tooltip text={translations.tooltip.navbar.todolist} vs={62} hs={50} position="top right" />
              </BackgroundLink>
              <NavLink to="/team" className={this.isTeam() && 'active'}>
                <Icon
                  size={24}
                  icon="Team"
                  fill={this.isTeam() ? styles.colors.primaryColor : styles.colors.darkGrey}
                  dot={elementHasNotifications(notifications, 'teamlist')}
                />
                <Tooltip text={translations.tooltip.navbar.teamlist} vs={62} hs={50} position="top right" />
              </NavLink>
              <NavLink to="/reports" className={this.isReports() && 'active'}>
                <Icon
                  size={24}
                  icon="Chart"
                  fill={this.isReports() ? styles.colors.primaryColor : styles.colors.darkGrey}
                />
                <Tooltip text={translations.tooltip.navbar.reports} vs={62} hs={50} position="top right" />
              </NavLink>
            </div>
            <div className="section">
              <BackgroundFakeLink onClick={() => this.setState({ showSupportChat: !showSupportChat })}>
                <BackgroundIcon size={24} icon="QuestionMark" fill="white" isActive={showSupportChat} />
              </BackgroundFakeLink>

              <NavLink to="/settings" className={this.isSettings() && 'active'}>
                <Icon
                  size={24}
                  icon="Settings"
                  fill={this.isSettings() ? styles.colors.primaryColor : styles.colors.darkGrey}
                />
                <Tooltip text={translations.tooltip.navbar.settings} vs={62} hs={50} position="top right" />
              </NavLink>
            </div>
          </div>
        </div>
        {showSupportChat && <DesktopSupportChat onClose={() => this.setState({ showSupportChat: false })} />}
      </React.Fragment>
    ) : null
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null,
    null,
    {
      pure: true
    }
  )(Navbar)
)

const linkStyle = css`
  display: block;
  padding: 28px;
  position: relative;
  cursor: pointer;
  ${props =>
    !props.disabled &&
    css`
      &:hover svg,
      &:hover path {
        fill: ${styles.colors.primaryColor};
      }
    `}
`

const backgroundLinkStyle = css`
  display: block;
  padding: 28px;
  position: relative;
  cursor: pointer;
  &:hover .todolist-icon {
    background-color: ${styles.colors.primaryColor};
  }
`
const indicatorSidebar = css`
  &:after {
    content: '';
    position: absolute;
    bottom: 10px;
    top: 10px;
    left: 0;
    width: 2px;
    background-color: ${styles.colors.primaryColor};
    transform: scale(0);
    transition: all 0.15s ease-in-out;
  }
  &:hover,
  &.active {
    color: ${styles.colors.primaryColor};
    &:after {
      transform: scale(1);
    }
  }
`

const NavLink = styled(Link)`
  ${linkStyle}
  ${indicatorSidebar}
`

const BackgroundLink = styled(Link)`
  ${backgroundLinkStyle}
  ${indicatorSidebar}
`

const BackgroundFakeLink = styled.div`
  ${backgroundLinkStyle}
`

const BackgroundIcon = styled(Icon)`
  transition: background-color 0.2s ease;
  background-color: ${props => (props.isActive ? styles.colors.primaryColor : styles.colors.darkGrey)};
  padding: 5px;
  border-radius: 10px;
  &:hover {
    background-color: ${styles.colors.primaryColor};
  }
`



// WEBPACK FOOTER //
// ./src/features/layout/components/navbarDesktop/index.js